// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__2cjx7","show_deals":"styles_show_deals__m4rok"};